import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAccessToken } from '../authHelper';
import "./USDIStats.css";

const AdminWhitelistTable = () => {
    const [admins, setAdmins] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [showAddModal, setShowAddModal] = useState(false);
    const [walletAddress, setWalletAddress] = useState('');
    const [note, setNote] = useState('');
    const [addError, setAddError] = useState('');

    const fetchAdmins = async () => {
        try {
            const access_token = await getAccessToken();
            if (!access_token) {
                setLoading(false);
                return;
            }
            const response = await axios.get(
                'https://max1-funding-arb.uc.r.appspot.com/admin-whitelist',
                { headers: { Authorization: `Bearer ${access_token}` } }
            );
            setAdmins(response.data?.data || []);
        } catch (err) {
            console.error('Error fetching admin whitelist:', err);
            setError('Error fetching admin whitelist.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAdmins();
    }, []);

    const handleAddAdmin = async () => {
        setAddError('');
        if (!walletAddress) {
            setAddError('Please enter a wallet address.');
            return;
        }
        try {
            const access_token = await getAccessToken();
            if (!access_token) {
                return;
            }
            await axios.post(
                'https://max1-funding-arb.uc.r.appspot.com/admin-whitelist',
                { wallet_address: walletAddress, note: note || null },
                { headers: { Authorization: `Bearer ${access_token}` } }
            );
            setWalletAddress('');
            setNote('');
            setShowAddModal(false);
            fetchAdmins();
        } catch (err) {
            console.error('Error adding admin whitelist:', err);
            setAddError('Failed to add admin. Please try again.');
        }
    };

    const handleDeleteAdmin = async (adminId) => {
        if (!window.confirm('Are you sure you want to delete this admin?')) {
            return;
        }
        try {
            const access_token = await getAccessToken();
            if (!access_token) {
                return;
            }
            await axios.delete(
                'https://max1-funding-arb.uc.r.appspot.com/admin-whitelist',
                {
                    headers: { Authorization: `Bearer ${access_token}` },
                    data: { id: adminId }
                }
            );
            fetchAdmins();
        } catch (err) {
            console.error('Error deleting admin whitelist:', err);
            setError('Failed to delete admin.');
        }
    };

    if (loading) {
        return <p>Loading admin whitelist...</p>;
    }

    if (error) {
        return <p className="error">{error}</p>;
    }

    return (
        <div>
            <div className="pagination-outer-container">
                <button className="tableDownloadButton" onClick={() => setShowAddModal(true)}>
                    Add Admin
                </button>
            </div>
            <div className="table-responsive noto">
                <table className="table table-striped table-bordered mt-3">
                    <thead className="thead-dark">
                        <tr>
                            <th>ID</th>
                            <th>Wallet Address</th>
                            <th>Note</th>
                            <th>Created At</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {admins.length > 0 ? (
                            admins.map((admin) => (
                                <tr key={admin.id || admin.wallet_address}>
                                    <td>{admin.id ?? ''}</td>
                                    <td>{admin.wallet_address ?? ''}</td>
                                    <td>{admin.note ?? ''}</td>
                                    <td>{admin.created_at ?? ''}</td>
                                    <td>
                                        <button
                                            type="button"
                                            className="btn btn-outline-danger btn-sm"
                                            onClick={() => handleDeleteAdmin(admin.id)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5">No admin wallets found.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {showAddModal && (
                <div
                    className="modal d-block"
                    tabIndex="-1"
                    role="dialog"
                    style={{ background: 'rgba(0,0,0,0.5)' }}
                >
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Add Admin Wallet</h5>
                            </div>
                            <div className="modal-body">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter wallet address"
                                    value={walletAddress}
                                    onChange={(e) => setWalletAddress(e.target.value)}
                                />
                                <textarea
                                    className="form-control mt-2"
                                    placeholder="Optional note"
                                    rows="3"
                                    value={note}
                                    onChange={(e) => setNote(e.target.value)}
                                />
                                {addError && (
                                    <div className="alert alert-danger mt-2">
                                        {addError}
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button
                                    type="button"
                                    className="btn btn-secondary"
                                    onClick={() => setShowAddModal(false)}
                                >
                                    Close
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-primary"
                                    onClick={handleAddAdmin}
                                >
                                    Add Admin
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminWhitelistTable;
